import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import NavLink from './NavLink';
import { cva } from 'class-variance-authority';
import {
  getCSSColorHoverText,
  getCSSColorText,
  getCSSSizeLgText,
  getCSSSizeMdText,
  getCSSSizeSmText,
} from '~/utilities/getCSS';
import { getFontSizeObject } from '~/utilities/getFontSizeObject';

const navClass = cva(
  'grid gap-y-2.5 gap-x-8 lg:gap-x-20 grid-cols-auto-2 md:grid-cols-auto-4 lg:grid-cols-auto-5',
  {
    variants: {
      color: getCSSColorText(),
      sizeSm: getCSSSizeSmText(),
      sizeMd: getCSSSizeMdText(),
      sizeLg: getCSSSizeLgText(),
    },
  }
);

const buttonClass = cva('text-left', {
  variants: {
    color: getCSSColorText(),
    hoverColor: getCSSColorHoverText(),
    sizeSm: getCSSSizeSmText(),
    sizeMd: getCSSSizeMdText(),
    sizeLg: getCSSSizeLgText(),
  },
});

export default component$((): JSX.Element => {
  const {
    themeComponents: { footer },
    payloadToSSR: { layout },
  } = useContext(AppDataContext);

  return (
    <nav class='w-full md:flex md:justify-center lg:max-w-5xl mx-auto py-5'>
      <ul
        class={navClass({
          color: footer.linksIdleColor.value,
          ...getFontSizeObject(footer, 'linksFontSize'),
        })}
      >
        {layout.footer.links?.value.map((each, index) => (
          <NavLink key={index} item={each} />
        ))}
        <li>
          <button
            onClick$={() => window.Didomi && window.Didomi.preferences.show()}
            type='button'
            class={buttonClass({
              color: footer.linksIdleColor.value,
              hoverColor: footer.linksHoverStateColor.value,
              ...getFontSizeObject(footer, 'linksFontSize'),
            })}
          >
            Cookie Preferences
          </button>
        </li>
      </ul>
    </nav>
  );
});
